import React from 'react';

interface SelectionBarProps {
  selectedName: string | null;
  onClear: () => void;
  onContinue: () => void;
}

const SelectionBar = ({
  selectedName,
  onClear,
  onContinue,
}: SelectionBarProps) => {
  if (!selectedName) return null;

  return (
    <div className="selection-bar visible">
      <div className="selection-bar-left">
        <span className="selection-info">{selectedName} selected</span>
        <button type="button" className="clear-btn" onClick={onClear}>
          Clear
        </button>
      </div>
      <button type="button" className="continue-btn" onClick={onContinue}>
        Continue →
      </button>
    </div>
  );
};

export default SelectionBar;
